<template>
  <div class="admin-layout">
    <!-- 左侧固定导航栏 -->
    <Sidebar class="sidebar" />

    <!-- 主内容区域 -->
    <div class="main-area">
      <!-- 顶部导航栏 -->
      <Topbar class="topbar" />

      <!-- 路由渲染区域 -->
      <div class="content-area">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/admin/Sidebar.vue'
import Topbar from '@/components/admin/Topbar.vue'

export default {
  name: 'AdminLayout',
  components: { Sidebar, Topbar }
}
</script>

<style scoped>
.admin-layout {
  display: flex;
  height: 100vh;
  overflow: hidden;
  background-color: #f4f7fc;
}

.sidebar {
  width: 220px;
  background-color: #001529;
  color: #fff;
  flex-shrink: 0;
}

.main-area {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.topbar {
  height: 60px;
  background: linear-gradient(135deg, #0052cc, #2684ff);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.content-area {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  background-color: #f4f7fc;
}
</style>
